<div id="gh-favorite-button" class="centered-vert hov-cursor-p justify-cont-c" (click)="toggleFavorite()">
  <ui-icon class="fs-14px" *ngIf="!isFavorite" uiTheme="outline" uiType="favorite"></ui-icon>
  <ui-icon class="fs-14px" *ngIf="isFavorite" uiTheme="fill" uiType="color-star-orange-stroke"></ui-icon>
</div>
